import { closest, removeClass, addClass, removeNode } from '@utils/domUtils';
import { stripWhitespace, stripTags } from '@utils/stringUtils';

/* global FormValidation */

export function createCategoryValidations(form) {
  return FormValidation.formValidation(form, {
    fields: {
      industry: {
        validators: {
          notEmpty: {
            message: 'Bitte Kategorie wählen',
          },
        },
      },
      subIndustry: {
        validators: {
          notEmpty: {
            message: 'Bitte Unterkategorie wählen',
          },
        },
      },
      jobProfile: {
        validators: {
          notEmpty: {
            message: 'Bitte Jobprofil wählen',
          },
        },
      },
      customJobProfile: {
        validators: {
          notEmpty: {
            message: 'Bitte Beschreibung eintragen',
          },
        },
      },
    },
    plugins: {
      trigger: new FormValidation.plugins.Trigger({
        event: 'input change validate',
      }),

      bootstrap: new FormValidation.plugins.Bootstrap({
        defaultMessageContainer: false,
        rowSelector: (field, ele) => {
          if (field === 'jobProfile' || field === 'customJobProfile') {
            return '.select-job-profile-wrapper';
          }

          return '.form-group';
        },
      }),

      message: new FormValidation.plugins.Message({
        clazz: 'fv-help-block',
        container: (field, ele) => {
          if (field === 'jobProfile') {
            return closest(ele, '.select-job-profile-wrapper').querySelector(
              '.error-message-wrapper',
            );
          }

          if (field === 'customJobProfile') {
            return closest(ele, '.custom-job-profile-wrapper').querySelector(
              '.error-message-wrapper',
            );
          }

          return closest(ele, '.form-input-wrapper');
        },
      }),

      excluded: new FormValidation.plugins.Excluded({
        // NOTE: exclude customJobProfile validation if setCustomJobProfile checkbox has not been checked
        excluded: field =>
          field === 'customJobProfile' &&
          !form.querySelector('[name="jobProfile"][value="setCustomJobProfile"]').checked,
      }),
    },
  });
}

export function createGeneralValidations(form) {
  return FormValidation.formValidation(form, {
    fields: {
      jobTitle: {
        validators: {
          notEmpty: {
            message: 'Inseratstitel ist ein Pflichtfeld',
          },
        },
      },
      address: {
        validators: {
          notEmpty: {
            message: 'Arbeitsort ist ein Plichtfeld',
          },
        },
      },
      'workTimes[]': {
        validators: {
          choice: {
            min: 1,
            message: 'Bitte Arbeitszeit wählen',
          },
        },
      },
      'employmentTypes[]': {
        validators: {
          choice: {
            min: 1,
            message: 'Bitte geben Sie die Anstellungsart an',
          },
        },
      },
    },
    plugins: {
      trigger: new FormValidation.plugins.Trigger(),

      bootstrap: new FormValidation.plugins.Bootstrap({
        defaultMessageContainer: false,
      }),

      message: new FormValidation.plugins.Message({
        clazz: 'fv-help-block',
        container: (field, ele) => {
          return closest(ele, '.form-group');
        },
      }),
    },
  });
}

export function createJobAdValidations(form) {
  const jobAdStep = form.querySelector('[data-step="jobAd"]');

  return FormValidation.formValidation(form, {
    fields: {
      _combinedJobAdContentValidator: {
        validators: {
          callback: {
            message: 'Inhalt muss eine Mindestlänge von 100 Zeichen aufweisen.',
            callback: input => {
              // NOTE: remove hidden nodes before reading text...
              const contentSections = form
                .querySelector('.job-ad-content-sections')
                .cloneNode(true);
              [...contentSections.querySelectorAll('.hide')].forEach(element =>
                removeNode(element),
              );

              const text = stripWhitespace(stripTags(contentSections.textContent));
              const valid = text.length >= 100;

              const alreadyTriedNextStep = jobAdStep
                ? jobAdStep.getAttribute('data-tried-validating') === 'true'
                : true;

              // NOTE: only show / hide error message if already tried validating before
              if (alreadyTriedNextStep) {
                const errorMessageNode = form.querySelector('.JobAdEditor .error-message-card');

                if (valid) {
                  addClass(errorMessageNode, 'hidden-error-message');
                } else {
                  removeClass(errorMessageNode, 'hidden-error-message');
                }
              }

              return valid;
            },
          },
        },
      },
    },
    plugins: {
      trigger: new FormValidation.plugins.Trigger({
        event: 'validate',
      }),

      message: new FormValidation.plugins.Message({
        container: (field, ele) => {
          return closest(ele, '.JobAdEditor').querySelector('.error-message-wrapper');
        },
      }),
    },
  });
}

export function createPublishChannelsValidations(form) {
  return FormValidation.formValidation(form, {});
}

export function createSummaryValidations(form) {
  return FormValidation.formValidation(form, {});
}
